<template>
  <div>
    <h1>Accueil</h1>
    <img src="@/assets/aws-hero-unicorn.webp" alt="AWS Superhero with Pink Unicorn">
  </div>
</template>

<script>
export default {
  name: 'HomeView',
}
</script>

<style>
/* Ajoutez vos styles ici */
</style>

